import { ChangeDetectorRef, Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    standalone: false,
    selector: 'app-field-error',
    templateUrl: './field-error.component.html',
    styleUrl: './field-error.component.scss',
})
export class FieldErrorComponent implements OnInit {
    private readonly cdr = inject(ChangeDetectorRef);
    private readonly destroyRef = inject(DestroyRef);

    @Input({ required: true }) control!: AbstractControl | null;
    @Input({ required: true }) fieldName!: string;
    @Input() testId: string | null = null;

    ngOnInit(): void {
        this.control?.events
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.cdr.markForCheck());
    }

    get errorMessage(): string | null {
        const errors = this.control?.touched ? this.control.errors : null;
        if (!errors) return null;
        if (errors['required']) return `${this.fieldName} is required.`;
        if (errors['minlength']) {
            return `${this.fieldName} must be at least ${errors['minlength'].requiredLength} characters long.`;
        }
        if (errors['maxlength']) {
            return `${this.fieldName} cannot be longer than ${errors['maxlength'].requiredLength} characters.`;
        }
        if (errors['email']) return 'Please enter a valid email address.';
        if (errors['pattern']) return `${this.fieldName} is not valid.`;
        if (errors['min']) return `${this.fieldName} must be at least ${errors['min'].min}.`;
        if (errors['max']) return `${this.fieldName} must be at most ${errors['max'].max}.`;
        return `${this.fieldName} is not valid.`;
    }
}
